import React from "react";
import { RollAdsItem } from "./roll-ads-list/roll-ads-empty/RollAdsItem";
import { RollAdsList } from "./roll-ads-list/roll-ads-item";

interface RollAdsProps {
  campaigns: { title: string; videos: string; categories: string[], campaignId: string; visibility: boolean; }[];
  handleDeleteCampaign: (campaignId: string) => Promise<void>;
  fetchCampaigns: () => void
  loading: boolean;
}

export const RollAds: React.FC<RollAdsProps> = ({ campaigns, handleDeleteCampaign, fetchCampaigns, loading }) => {
  if (loading) return null;
  return (
    <>
      {campaigns.length > 0 ? (
        <RollAdsList
          campaigns={campaigns}
          handleDeleteCampaign={handleDeleteCampaign}
          fetchCampaigns={fetchCampaigns}
        />
      ) : (
        <RollAdsItem fetchCampaigns={fetchCampaigns} />
      )}
    </>
  );
};
